import axiosInstance from '../../utils/axiosConfig';

// Reporting « missions par expert » (MAE) : l'export est calculé par ms-inspection et renvoyé en xlsx.
// Pas d'état Redux : le fichier est téléchargé directement par le navigateur.
export const downloadMissionsPerExpert = async ({ from, to }) => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Token is missing');
    const response = await axiosInstance.get(
        `${process.env.REACT_APP_BACKEND_URL_MS_INSPECTION}/reporting/missionsPerExpert`,
        {
            params: { from, to },
            responseType: 'blob',
            timeout: 180000,
            headers: { Authorization: `Bearer ${token}` },
        }
    );
    const disposition = response.headers['content-disposition'] || '';
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const fileName = match ? match[1] : `missions_par_expert_${from}_${to}.xlsx`;
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    let stats = null;
    try { stats = JSON.parse(response.headers['x-report-stats'] || 'null'); } catch (e) { stats = null; }
    return { fileName, stats };
};

// Le serveur répond en JSON pour les erreurs, mais axios a reçu un blob : on le relit pour afficher le message
export const readBlobError = async (error, fallback) => {
    const data = error?.response?.data;
    if (data instanceof Blob) {
        try {
            const parsed = JSON.parse(await data.text());
            if (Array.isArray(parsed.errors)) return parsed.errors.join(' ');
            if (parsed.error) return parsed.error;
            if (parsed.message) return parsed.message;
        } catch (e) { /* corps non JSON */ }
    }
    if (error?.code === 'ECONNABORTED') return 'Le calcul du rapport a dépassé le délai autorisé. Réduisez la plage de dates.';
    if (error?.response?.status === 429) return 'Un export est déjà en cours, réessayez dans quelques instants.';
    if (error?.response?.status === 504) return 'Le serveur a mis trop de temps à répondre. Réduisez la plage de dates.';
    return fallback;
};
